/**
 * Vista: Detalle/Nuevo Checklist de Entrega
 * Formato: AMX-VTA-FR-11_R7
 */

import ventasService from '../services/ventas.service.js';
import recepcionService from '../services/recepcion.service.js';
import personaService from '../services/persona.service.js';
import remisionService from '../services/remision.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

import { hoyLocal } from '../utils/fechas.js';
import { consultarDanos, avisoDanosHtml } from '../utils/avisoDanos.js';
// Items del checklist según formato AMX-VTA-FR-11_R7
const DOCUMENTOS_TEMPLATE = [
  { numero: 1, documento: 'PEDIDO AGROMX', codigo: 'AMX-VTA-FR-05', condicion: 'Verificar', accion: null, condicion_bloqueada: false, accion_bloqueada: true },
  { numero: 2, documento: 'ENTREGA DE TRACTOR', codigo: 'AMX-VTA-FR-07', condicion: 'Para llenar', accion: 'Firmada', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 3, documento: 'ENCUESTA DE SATISFACCIÓN VENTA', codigo: 'AMX-VTA-FR-08', condicion: 'Para llenar', accion: 'Firmada', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 4, documento: 'CERTIFICADO DE VENTA TRACTOR Y COSECHADORA', codigo: 'AMX-VTA-FR-06', condicion: 'Para firmar', accion: 'Fotografía', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 5, documento: 'PÓLIZA DE GARANTÍA', codigo: 'AMX-PVTA-FR-03', condicion: 'Para firmar', accion: 'Fotografía', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 6, documento: 'QUEJAS O SUGERENCIAS', codigo: 'AMX-CC-FR-07', condicion: 'Para llenar', accion: 'Firmada', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 7, documento: 'CARNET DE SERVICIOS', codigo: 'AMX-PVTA-FR-01 CARNET DE SERVICIOS TRACTORES NO CERTIFICADOS\nAMX-PVTA-FR-05 CARNET DE SERVICIOS TRACTORES CERTIFICADOS', condicion: 'Para llenar', accion: 'Fotografía', condicion_bloqueada: false, accion_bloqueada: false },
  { numero: 8, documento: 'MANUAL DE OPERACIÓN', codigo: 'AMX-VTA-MN-01 MANUAL DE OPERACIÓN TE254 CLASSIC\nAMX-VTA-MN-02 MANUAL DE OPERACIÓN TE354 III GEN\nAMX-VTA-MN-03 MANUAL DE OPERACIÓN TB504 III GEN\nMANUAL DE OPERACIÓN TH754 III GEN / TD904 III GEN / TD1104 III GEN', condicion: 'Para entregar', accion: null, condicion_bloqueada: false, accion_bloqueada: true },
  { numero: 9, documento: 'CAJA DE HERRAMIENTAS COMPLETA', codigo: null, condicion: 'Para entregar', accion: null, condicion_bloqueada: false, accion_bloqueada: true },
  { numero: 10, documento: 'CAJA DE REGALOS', codigo: null, condicion: 'Para entregar', accion: null, condicion_bloqueada: false, accion_bloqueada: true },
  { numero: 11, documento: 'EVIDENCIA DE ENTREGA', codigo: null, condicion: null, accion: 'Fotografía', condicion_bloqueada: true, accion_bloqueada: false }
];

export default {
  data: {
    checklist: null,
    isNew: false,
    hasUnsavedChanges: false,
    distribuidores: [],
    responsablesLinea: [],
    responsablesArea: []
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nuevo';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
          <h2 class="card-title">${this.data.isNew ? 'Nuevo Checklist de Entrega' : 'Checklist de Entrega'}</h2>
          <div id="headerButtons" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/ventas/checklist-entrega')">← Volver</button>
          </div>
        </div>
        <div id="checklistContent"><div style="text-align: center; padding: 2rem;">Cargando...</div></div>
      </div>
    `;
  },

  async afterRender(params) {
    window.checklistDocDetalleView = this;
    this.data.hasUnsavedChanges = false;
    this.injectStyles();

    // Cargar catálogos — distribuidores y responsables desde usuarios con persona (patrón unificado)
    try {
      const usuariosResp = await api.get('/usuarios/responsables').catch(() => ({ data: [] }));
      const todos = Array.isArray(usuariosResp.data) ? usuariosResp.data : (usuariosResp.data?.usuarios || []);
      const usuariosConPersona = todos
        .filter(u => u.persona_id)
        .map(u => ({
          id: u.persona_id,
          nombre_completo: u.persona_nombre_completo || u.nombre_completo
        }));

      this.data.distribuidores = usuariosConPersona;
      this.data.responsablesLinea = usuariosConPersona;
      this.data.responsablesArea = usuariosConPersona;
    } catch (e) { /* catálogos opcionales */ }

    if (this.data.isNew) {
      this.renderFormularioNuevo();
    } else {
      await this.cargarChecklist(params.id);
    }
  },

  injectStyles() {
    if (document.getElementById('chk-detalle-styles')) return;
    const style = document.createElement('style');
    style.id = 'chk-detalle-styles';
    style.textContent = `
      .pnc-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
      .pnc-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .pnc-tab:hover:not(.active):not(:disabled) { color: #374151; border-bottom-color: #d1d5db; }
      .pnc-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      .pnc-tab:disabled { color: #6b7280; opacity: 0.4; cursor: not-allowed; }
      .firma-box { position: relative; border: 1px solid var(--border-color); border-radius: 8px; overflow: hidden; background: #fff; margin-bottom: 0.5rem; }
      .firma-canvas-new { width: 100%; height: 120px; display: block; }
      .firma-placeholder { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: var(--text-secondary); font-size: 0.85rem; pointer-events: none; }
      .firma-limpiar { font-size: 0.8rem; color: var(--primary); text-decoration: none; }
      .firma-limpiar:hover { text-decoration: underline; }
      .chk-card { border: 1px solid var(--border-color); border-radius: 8px; padding: 0.75rem; margin-bottom: 0.5rem; background: var(--bg-primary); }
      .chk-card-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.5rem; }
      .chk-card-num { font-weight: 700; color: var(--primary); font-size: 0.85rem; }
      .chk-card-doc { font-weight: 600; font-size: 0.85rem; }
      .chk-card-codigo { font-size: 0.7rem; color: var(--text-secondary); }
      .chk-card-row { display: flex; justify-content: space-between; align-items: center; padding: 0.25rem 0; font-size: 0.8rem; }
      .chk-card-label { color: var(--text-secondary); }
      .chk-cards-container { display: none; }
      .chk-table-container { display: block; }
      @media (max-width: 640px) {
        .pnc-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem; padding: 0.3rem; }
        .pnc-tab { padding: 0.4rem 0.5rem; font-size: 0.75rem; }
        .pnc-grid-2col { grid-template-columns: 1fr !important; }
        .chk-cards-container { display: block; }
        .chk-table-container { display: none; }
      }
    `;
    document.head.appendChild(style);
  },

  async cargarChecklist(id) {
    try {
      const response = await ventasService.obtenerChecklistDocumentos(id);
      this.data.checklist = response.data || response;
      this.data.hasUnsavedChanges = false;

      // Buscar remisión activa para este tractor (para item #4 del FR-11)
      try {
        const numSerie = this.data.checklist?.num_serie;
        if (numSerie) {
          const resRem = await remisionService.obtenerActivaPorTractor(numSerie);
          this.data.remisionActiva = resRem?.data || resRem || null;
        }
      } catch { this.data.remisionActiva = null; }

      if (this.data.checklist.completada) {
        this.renderCompletado();
      } else {
        this.renderFormularioEdicion();
      }
    } catch (error) {
      toast.error('Error al cargar checklist');
      router.navigate('/ventas/checklist-entrega');
    }
  },

  /**
   * Render del botón "Generar Remisión" / "Ver Remisión" para el item #4
   * del checklist FR-11. Si ya existe remisión activa para el tractor,
   * muestra link al detalle. Si no, muestra botón para generar.
   */
  _renderRemisionBtn() {
    const c = this.data.checklist;
    if (!c) return '';
    const numSerie = c.num_serie;
    if (!numSerie) return '';
    const checklistId = c.id;
    const rem = this.data.remisionActiva;
    if (rem && rem.id) {
      // Ya hay remisión activa — badge informativo (con click-through al detalle).
      const esPendiente = (rem.completada === 0 || rem.completada === false);
      const bg = esPendiente ? '#fef3c7' : '#d1fae5';
      const color = esPendiente ? '#92400e' : '#065f46';
      const icon = esPendiente ? '📝' : '✅';
      const label = esPendiente ? 'Pendiente' : 'Remisión';
      return `
        <div style="margin-top:0.5rem;">
          <a href="javascript:void(0)" onclick="window.checklistDocDetalleView._irARemision(${rem.id})"
             style="display:inline-block;padding:0.3rem 0.6rem;background:${bg};color:${color};border-radius:4px;font-size:0.75rem;font-weight:600;text-decoration:none;">
            ${icon} ${label} ${rem.numero_remision || '#' + rem.id}
          </a>
        </div>
      `;
    }
    // Sin remisión: solo aviso visual. La generación se hace desde el módulo Remisiones.
    return `<div style="margin-top:0.4rem;font-size:0.75rem;color:var(--gray-500);">⚠️ Sin remisión generada — créala desde el módulo Remisiones.</div>`;
  },

  _irARemision(id) {
    router.navigate(`/ventas/remisiones/${id}`);
  },

  // ======================== FORMULARIO NUEVO ========================

  renderFormularioNuevo() {
    const container = document.getElementById('checklistContent');

    container.innerHTML = `
      <!-- Búsqueda por NS -->
      <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
        <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
        <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
        <div style="display: flex; gap: 0.75rem; align-items: center;">
          <input type="text" id="numSerieBuscar" class="form-input" style="flex: 1;" placeholder="Ej: TE354-2026-0127" />
          <button type="button" class="btn btn-primary" onclick="window.checklistDocDetalleView.buscarTractor()">Buscar</button>
        </div>
        <div id="tractorResult" style="margin-top: 1rem;"></div>
      </div>

      <div id="formularioPrincipal" style="display: none;">
        <!-- Datos generales -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
          <input type="hidden" id="chkNumSerie" />
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="pnc-grid-2col">
            <div class="form-group">
              <label class="form-label">Marca</label>
              <input type="text" id="chkMarca" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Modelo</label>
              <input type="text" id="chkModelo" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Fecha</label>
              <input type="date" id="chkFecha" class="form-input" value="${hoyLocal()}" />
            </div>
            <div class="form-group">
              <label class="form-label">Distribuidor</label>
              <select id="chkDistribuidor" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.distribuidores.map(d => `<option value="${d.nombre_completo}">${d.nombre_completo}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Tipo de Venta *</label>
              <div style="display: flex; gap: 1.5rem; margin-top: 0.25rem;">
                <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                  <input type="radio" name="chkTipoVenta" value="credito" /> Crédito
                </label>
                <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                  <input type="radio" name="chkTipoVenta" value="contado" /> Contado
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="pnc-tabs-bar">
          <button class="pnc-tab active" onclick="window.checklistDocDetalleView.showTab('documento')">Documento</button>
          <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('notas')">Notas</button>
          <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('firmas')">Responsables</button>
        </div>

        <!-- Tab Documento -->
        <div class="pnc-panel" id="panel-documento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          ${this._renderDocumentoPanel([])}
        </div>

        <!-- Tab Notas -->
        <div class="pnc-panel" id="panel-notas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group">
            <label class="form-label">Notas adicionales</label>
            <textarea id="chkNotas" class="form-input" style="text-transform: uppercase;" rows="6" placeholder="Notas adicionales..."></textarea>
          </div>
        </div>

        <!-- Tab Firmas -->
        <div class="pnc-panel" id="panel-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="pnc-grid-2col">
            <div class="form-group">
              <label class="form-label">Responsable de línea de producto</label>
              <select id="chkRespLinea" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.responsablesLinea.map(r => `<option value="${r.nombre_completo}">${r.nombre_completo}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Responsable de área de producción</label>
              <select id="chkRespArea" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.responsablesArea.map(r => `<option value="${r.nombre_completo}">${r.nombre_completo}</option>`).join('')}
              </select>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1.5rem;">
          <button type="button" class="btn btn-secondary" onclick="router.navigate('/ventas/checklist-entrega')">Cancelar</button>
          <button type="button" class="btn btn-success" onclick="window.checklistDocDetalleView.guardarNuevo()">Crear Checklist</button>
        </div>
      </div>
    `;

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        // Cualquier edición del num_serie invalida el resultado previo,
        // sea éste el form precargado (búsqueda OK) o un banner de error
        // (falta FR-07, ya existe FR-11, etc.). El usuario debe darle
        // Buscar de nuevo para validar el nuevo num_serie.
        this.data.tractor = null;
        const fp = document.getElementById('formularioPrincipal');
        if (fp) fp.style.display = 'none';
        const result = document.getElementById('tractorResult');
        if (result) result.innerHTML = '';
      });
    }
  },

  async buscarTractor() {
    const numSerie = (document.getElementById('numSerieBuscar')?.value || '').trim().toUpperCase();
    if (!numSerie) { toast.error('Ingrese el número de serie'); return; }

    const resultDiv = document.getElementById('tractorResult');
    const fp = document.getElementById('formularioPrincipal');
    resultDiv.innerHTML = '<p style="color:var(--gray-600);">Buscando...</p>';

    // Una sola llamada: el lookup del backend aplica el gate completo
    // (tractor existe + FR-07 vigente + sin FR-11 activo). Fallar al buscar
    // evita que el usuario llene el form para descubrir el error al guardar.
    try {
      const response = await ventasService.lookupTractorParaChecklist(numSerie);
      const data = response?.data || response;
      const tractor = data.tractor;
      this.data.tractor = tractor;

      // C-323c: aviso visible si la unidad tiene daños por corregir (no impide registrar el FR-11)
      resultDiv.innerHTML = avisoDanosHtml(await consultarDanos(numSerie), { bloquea: false });
      if (fp) fp.style.display = 'block';
      document.getElementById('chkMarca').value = tractor.marca || '';
      document.getElementById('chkModelo').value = tractor.modelo || '';
      document.getElementById('chkNumSerie').value = numSerie;

      // Pre-seleccionar el distribuidor heredado del FR-07. Si el nombre
      // coincide con una opción del select, se selecciona; si no (porque la
      // lista de distribuidores se filtró o el nombre cambió), inyectamos la
      // opción para que igual quede precargada y el usuario solo confirme.
      if (data.distribuidor?.nombre_completo) {
        const select = document.getElementById('chkDistribuidor');
        if (select) {
          const nombre = data.distribuidor.nombre_completo;
          const existe = Array.from(select.options).some(o => o.value === nombre);
          if (!existe) {
            const opt = document.createElement('option');
            opt.value = nombre;
            opt.textContent = nombre;
            select.appendChild(opt);
          }
          select.value = nombre;
        }
      }
    } catch (err) {
      this.data.tractor = null;
      if (fp) fp.style.display = 'none';
      this._renderLookupError(err, resultDiv, numSerie);
    }
  },

  _renderLookupError(err, resultDiv, numSerie) {
    if (!resultDiv) return;
    const code = err?.code;
    const details = err?.details || {};
    const msg = err?.message || 'No se pudo cargar el tractor';

    const tplAviso = (titulo, sub, linkHtml, color = 'warning') => {
      const styles = color === 'danger'
        ? 'background:#fee2e2;color:#991b1b;border:1px solid #fca5a5;'
        : 'background:#fef3c7;color:#92400e;border:1px solid #fbbf24;';
      return `
        <div style="padding:0.75rem 1rem;${styles}border-radius:8px;">
          <strong>${titulo}</strong><br/>
          ${sub ? `<span style="font-size:0.85rem;">${sub}</span>` : ''}
          ${linkHtml ? `<div style="margin-top:0.5rem;">${linkHtml}</div>` : ''}
        </div>
      `;
    };

    if (code === 'TRACTOR_NO_ENCONTRADO') {
      resultDiv.innerHTML = tplAviso('No se encontró tractor con ese número de serie', '', '', 'danger');
      return;
    }

    if (code === 'ENTREGA_TRACTOR_REQUERIDA') {
      resultDiv.innerHTML = tplAviso(
        'Falta la Entrega de Tractor',
        'Primero realiza la Entrega de Tractor — ahí se asigna cliente y distribuidor. Sin ella no se puede crear el Checklist.',
        ''
      );
      return;
    }

    if (code === 'ENTREGA_TRACTOR_INCOMPLETA') {
      resultDiv.innerHTML = tplAviso(
        'La Entrega de Tractor no está completada',
        '',
        ''
      );
      return;
    }

    if (code === 'CHECKLIST_ENTREGA_YA_EXISTE') {
      const chk = details.checklist || {};
      resultDiv.innerHTML = tplAviso(
        'Ya existe un Checklist de Entrega para este tractor',
        chk.completada ? 'El checklist actual está completado. Edítalo o elimínalo antes de crear otro.' : 'Hay un checklist en borrador. Edítalo o elimínalo antes de crear otro.',
        ''
      );
      return;
    }

    // Fallback genérico (error inesperado, sin code reconocido)
    resultDiv.innerHTML = tplAviso(msg, '', '', 'danger');
  },

  async guardarNuevo() {
    const distribuidor = document.getElementById('chkDistribuidor')?.value;
    if (!distribuidor) { toast.error('Seleccione el distribuidor'); return; }
    const tipoVenta = document.querySelector('input[name="chkTipoVenta"]:checked')?.value;
    if (!tipoVenta) { toast.error('Seleccione el tipo de venta'); return; }
    const respLinea = document.getElementById('chkRespLinea')?.value;
    const respArea = document.getElementById('chkRespArea')?.value;
    if (!respLinea) { toast.error('Seleccione el responsable de línea de producto'); this.showTab('firmas'); return; }
    if (!respArea) { toast.error('Seleccione el responsable de área de producción'); this.showTab('firmas'); return; }

    const data = {
      num_serie: document.getElementById('chkNumSerie')?.value,
      fecha: document.getElementById('chkFecha')?.value || null,
      distribuidor: document.getElementById('chkDistribuidor')?.value || null,
      tipo_venta: tipoVenta,
      notas: document.getElementById('chkNotas')?.value?.trim()?.toUpperCase() || null,
      responsable_linea: document.getElementById('chkRespLinea')?.value || null,
      responsable_area: document.getElementById('chkRespArea')?.value || null
    };

    try {
      this._showProgress('Creando checklist...');
      const response = await ventasService.crearChecklistDocumentos(data);
      const checklist = response.data || response;

      // Guardar checkboxes marcados en el tab Documento
      const checkboxesMarcados = [];
      DOCUMENTOS_TEMPLATE.forEach(tmpl => {
        const cond = this._getCheckState(tmpl.numero, 'condicion');
        const acc = this._getCheckState(tmpl.numero, 'accion');
        if (cond || acc) {
          checkboxesMarcados.push({
            numero: tmpl.numero,
            condicion: cond,
            accion: acc
          });
        }
      });

      if (checkboxesMarcados.length > 0) {
        this._showProgress('Guardando items...');
        await ventasService.actualizarChecklistDocumentos(checklist.id, { items: checkboxesMarcados });
      }

      this._hideProgress();
      toast.success('Checklist creado exitosamente');
      router.navigate(`/ventas/checklist-entrega/${checklist.id}`);
    } catch (error) {
      this._hideProgress();
      // Defense in depth: el gate ya valida estos casos al buscar, pero si
      // alguien llega aquí (camino no convencional), mostramos modal con link.
      if (error?.code === 'ENTREGA_TRACTOR_REQUERIDA') {
        const ns = data.num_serie || '';
        const url = ns
          ? `/ventas/entregas/nueva?num_serie=${encodeURIComponent(ns)}`
          : '/ventas/entregas/nueva';
        modal.open(
          'Falta la Entrega de Tractor (FR-07)',
          `<p>${error.message}</p>
           <p style="margin-top:0.5rem;color:var(--gray-700);">La Entrega de Tractor asigna el cliente y distribuidor; sin ella no se puede crear el Checklist.</p>`,
          [
            { text: 'Cerrar', class: 'btn-secondary' },
            { text: 'Ir a Entrega de Tractor', class: 'btn-primary', onClick: () => router.navigate(url) }
          ]
        );
        return;
      }
      if (error?.code === 'ENTREGA_TRACTOR_INCOMPLETA') {
        const entregaId = error?.details?.entrega?.id;
        modal.open(
          'Entrega de Tractor (FR-07) no completada',
          `<p>${error.message}</p>`,
          [
            { text: 'Cerrar', class: 'btn-secondary' },
            ...(entregaId ? [{ text: 'Abrir Entrega', class: 'btn-primary', onClick: () => router.navigate(`/ventas/entregas/${entregaId}`) }] : [])
          ]
        );
        return;
      }
      toast.error(error.message || 'Error al crear checklist');
    }
  },

  // ======================== FORMULARIO EDICIÓN ========================

  renderFormularioEdicion() {
    const container = document.getElementById('checklistContent');
    const c = this.data.checklist;
    const items = c.items || [];

    container.innerHTML = `
      <!-- Datos generales fijos -->
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="pnc-grid-2col">
          <div class="form-group">
            <label class="form-label">Número de Serie</label>
            <input type="text" class="form-input" readonly value="${c.num_serie}" />
          </div>
          <div class="form-group">
            <label class="form-label">Marca</label>
            <input type="text" class="form-input" readonly value="${c.marca || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <input type="text" class="form-input" readonly value="${c.modelo || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha</label>
            <input type="date" id="chkFechaEdit" class="form-input" value="${c.fecha ? c.fecha.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Distribuidor</label>
            <input type="text" class="form-input" readonly value="${c.distribuidor || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Tipo de Venta</label>
            <div style="display: flex; gap: 1.5rem; margin-top: 0.25rem;">
              <label style="display: flex; align-items: center; gap: 0.5rem;">
                <input type="radio" name="chkTipoVentaEdit" value="credito" ${c.tipo_venta === 'credito' ? 'checked' : ''} /> Crédito
              </label>
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
                <input type="radio" name="chkTipoVentaEdit" value="contado" ${c.tipo_venta === 'contado' ? 'checked' : ''} /> Contado
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="pnc-tabs-bar">
        <button class="pnc-tab active" onclick="window.checklistDocDetalleView.showTab('documento')">Documento</button>
        <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('notas')">Notas</button>
        <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('firmas')">Firmas</button>
      </div>

      <!-- Tab Documento -->
      <div class="pnc-panel" id="panel-documento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        ${this._renderDocumentoPanel(items)}
      </div>

      <!-- Tab Notas -->
      <div class="pnc-panel" id="panel-notas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div class="form-group">
          <label class="form-label">Notas adicionales</label>
          <textarea id="chkNotas" class="form-input" style="text-transform: uppercase;" rows="6" placeholder="Notas adicionales...">${c.notas || ''}</textarea>
        </div>
      </div>

      <!-- Tab Firmas -->
      <div class="pnc-panel" id="panel-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div id="firmasContainer" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="pnc-grid-2col">
        </div>
      </div>

      <!-- Indicador de cambios sin guardar -->
      <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
        Hay cambios sin guardar
      </div>

      <!-- Botones -->
      <div style="display: flex; gap: 1rem; justify-content: flex-end;">
        <button type="button" class="btn btn-secondary" onclick="window.checklistDocDetalleView.volver()">Cancelar</button>
        <button type="button" class="btn btn-primary" onclick="window.checklistDocDetalleView.guardarCambios()">Guardar Cambios</button>
        ${permisos.can('checklist_entrega', 'cerrar') ? `<button type="button" class="btn btn-success" onclick="window.checklistDocDetalleView.completarChecklist()">Completar</button>` : ''}
      </div>
    `;

    // Detectar cambios
    document.querySelectorAll('#checklistContent input, #checklistContent textarea, #checklistContent select').forEach(el => {
      el.addEventListener('change', () => this._showUnsaved());
      el.addEventListener('input', () => this._showUnsaved());
    });
  },

  // ======================== VISTA COMPLETADO (readonly) ========================

  renderCompletado() {
    const container = document.getElementById('checklistContent');
    const c = this.data.checklist;
    const items = c.items || [];

    // Botones header
    const headerButtons = document.getElementById('headerButtons');
    if (headerButtons) {
      headerButtons.innerHTML = `
        <button class="btn btn-secondary" onclick="router.navigate('/ventas/checklist-entrega')">← Volver</button>
        ${permisos.canPrint('checklist_entrega') ? `<button class="btn btn-primary" onclick="window.checklistDocDetalleView.imprimir()">🖨️ Imprimir</button>
        <button class="btn btn-success" onclick="window.checklistDocDetalleView.descargarPDF()">📄 Descargar PDF</button>` : ''}
      `;
    }

    container.innerHTML = `
      <!-- Datos generales -->
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="pnc-grid-2col">
          <div class="form-group">
            <label class="form-label">Número de Serie</label>
            <input type="text" class="form-input" readonly value="${c.num_serie}" />
          </div>
          <div class="form-group">
            <label class="form-label">Marca</label>
            <input type="text" class="form-input" readonly value="${c.marca || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <input type="text" class="form-input" readonly value="${c.modelo || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha</label>
            <input type="date" class="form-input" readonly value="${c.fecha ? c.fecha.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Distribuidor</label>
            <input type="text" class="form-input" readonly value="${c.distribuidor || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Tipo de Venta</label>
            <input type="text" class="form-input" readonly value="${c.tipo_venta === 'credito' ? 'Crédito' : 'Contado'}" />
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="pnc-tabs-bar">
        <button class="pnc-tab active" onclick="window.checklistDocDetalleView.showTab('documento')">Documento</button>
        <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('notas')">Notas</button>
        <button class="pnc-tab" onclick="window.checklistDocDetalleView.showTab('firmas')">Firmas</button>
      </div>

      <!-- Tab Documento (readonly) -->
      <div class="pnc-panel" id="panel-documento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        <div class="table-container">
          <table class="table" style="font-size: 0.85rem;">
            <thead>
              <tr>
                <th style="width: 40px;">No.</th>
                <th>Formato</th>
                <th style="width: 100px;">Condición</th>
                <th style="width: 60px; text-align: center;">Estatus</th>
                <th style="width: 90px;">Acción</th>
                <th style="width: 60px; text-align: center;">Estatus</th>
              </tr>
            </thead>
            <tbody>
              ${this._renderItemsTablaReadonly(items)}
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tab Notas (readonly) -->
      <div class="pnc-panel" id="panel-notas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div class="form-group">
          <label class="form-label">Notas</label>
          <textarea class="form-input" rows="6" readonly>${c.notas || ''}</textarea>
        </div>
      </div>

      <!-- Tab Firmas (readonly) -->
      <div class="pnc-panel" id="panel-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="pnc-grid-2col">
          <div style="text-align: center; padding: 0.5rem;">
            ${c.responsable_linea_firma_url
              ? `<img src="${c.responsable_linea_firma_url}" style="width: 100%; max-height: 120px; object-fit: contain;" onerror="this.style.display='none'" />`
              : '<div style="min-height: 120px; display: flex; align-items: center; justify-content: center;"><span style="color: var(--text-secondary);">Sin firma</span></div>'
            }
            <hr style="border: none; border-top: 2px solid #000; margin: 0.5rem 0;" />
            <p style="margin: 0.25rem 0 0; font-weight: 700; font-size: 0.95rem; text-transform: uppercase;">${c.responsable_linea || ''}</p>
            <p style="margin: 0.25rem 0 0; color: var(--text-secondary); font-size: 0.85rem;">Resp. línea de producto</p>
          </div>
          <div style="text-align: center; padding: 0.5rem;">
            ${c.responsable_area_firma_url
              ? `<img src="${c.responsable_area_firma_url}" style="width: 100%; max-height: 120px; object-fit: contain;" onerror="this.style.display='none'" />`
              : '<div style="min-height: 120px; display: flex; align-items: center; justify-content: center;"><span style="color: var(--text-secondary);">Sin firma</span></div>'
            }
            <hr style="border: none; border-top: 2px solid #000; margin: 0.5rem 0;" />
            <p style="margin: 0.25rem 0 0; font-weight: 700; font-size: 0.95rem; text-transform: uppercase;">${c.responsable_area || ''}</p>
            <p style="margin: 0.25rem 0 0; color: var(--text-secondary); font-size: 0.85rem;">Resp. área de producción</p>
          </div>
        </div>
      </div>
    `;
  },

  _renderItemsTablaReadonly(items) {
    return DOCUMENTOS_TEMPLATE.map(tmpl => {
      const item = items.find(i => i.numero === tmpl.numero) || {};
      const condBloq = tmpl.condicion_bloqueada;
      const accBloq = tmpl.accion_bloqueada;
      const remisionBtn = tmpl.numero === 4 ? this._renderRemisionBtn() : '';

      return `
        <tr>
          <td style="text-align: center; font-weight: 600;">${tmpl.numero}</td>
          <td>
            <strong>${tmpl.documento}</strong>
            ${tmpl.codigo ? `<br/><span style="font-size: 0.75rem; color: var(--text-secondary);">${tmpl.codigo.replace(/\n/g, '<br>')}</span>` : ''}
            ${remisionBtn}
          </td>
          <td style="font-size: 0.8rem;">${condBloq ? '' : (tmpl.condicion || '')}</td>
          <td style="text-align: center;">
            ${condBloq ? '' : (item.condicion ? '✓' : '')}
          </td>
          <td style="font-size: 0.8rem;">${accBloq ? '' : (tmpl.accion || '')}</td>
          <td style="text-align: center;">
            ${accBloq ? '' : (item.accion ? '✓' : '')}
          </td>
        </tr>
      `;
    }).join('');
  },

  _renderItemsTabla(items) {
    return DOCUMENTOS_TEMPLATE.map(tmpl => {
      const item = items.find(i => i.numero === tmpl.numero) || {};
      const condBloq = tmpl.condicion_bloqueada;
      const accBloq = tmpl.accion_bloqueada;
      // Item #4 (FR-06 Remisión) tiene acción especial: generar/ver remisión
      const remisionBtn = tmpl.numero === 4 ? this._renderRemisionBtn() : '';

      return `
        <tr>
          <td style="text-align: center; font-weight: 600;">${tmpl.numero}</td>
          <td>
            <strong>${tmpl.documento}</strong>
            ${tmpl.codigo ? `<br/><span style="font-size: 0.75rem; color: var(--text-secondary);">${tmpl.codigo.replace(/\n/g, '<br>')}</span>` : ''}
            ${remisionBtn}
          </td>
          <td style="font-size: 0.8rem;">${condBloq ? '' : (tmpl.condicion || '')}</td>
          <td style="text-align: center;">
            ${condBloq ? '' : `<input type="checkbox" data-item="${tmpl.numero}" data-field="condicion" ${item.condicion ? 'checked' : ''} />`}
          </td>
          <td style="font-size: 0.8rem;">${accBloq ? '' : (tmpl.accion || '')}</td>
          <td style="text-align: center;">
            ${accBloq ? '' : `<input type="checkbox" data-item="${tmpl.numero}" data-field="accion" ${item.accion ? 'checked' : ''} />`}
          </td>
        </tr>
      `;
    }).join('');
  },

  _renderItemsCards(items) {
    return DOCUMENTOS_TEMPLATE.map(tmpl => {
      const item = items.find(i => i.numero === tmpl.numero) || {};
      const condBloq = tmpl.condicion_bloqueada;
      const accBloq = tmpl.accion_bloqueada;
      const remisionBtn = tmpl.numero === 4 ? this._renderRemisionBtn() : '';

      return `
        <div class="chk-card">
          <div class="chk-card-header">
            <div>
              <span class="chk-card-num">#${tmpl.numero}</span>
              <span class="chk-card-doc">${tmpl.documento}</span>
              ${tmpl.codigo ? `<div class="chk-card-codigo">${tmpl.codigo.replace(/\n/g, '<br>')}</div>` : ''}
              ${remisionBtn}
            </div>
          </div>
          ${condBloq ? '' : `
          <div class="chk-card-row">
            <span class="chk-card-label">Condición: ${tmpl.condicion || '-'}</span>
            <input type="checkbox" data-item="${tmpl.numero}" data-field="condicion" ${item.condicion ? 'checked' : ''} />
          </div>`}
          ${accBloq ? '' : `
          <div class="chk-card-row">
            <span class="chk-card-label">Acción: ${tmpl.accion || '-'}</span>
            <input type="checkbox" data-item="${tmpl.numero}" data-field="accion" ${item.accion ? 'checked' : ''} />
          </div>`}
        </div>
      `;
    }).join('');
  },

  _renderDocumentoPanel(items) {
    return `
      <p style="font-size: 0.8rem; color: var(--text-secondary); margin-bottom: 1rem; font-style: italic;">
        Coloque una "✓" en "Estatus" cuando se realice la acción previo y durante la entrega
      </p>
      <div class="chk-table-container">
        <div class="table-container">
          <table class="table" style="font-size: 0.85rem;">
            <thead>
              <tr>
                <th style="width: 40px;">No.</th>
                <th>Formato</th>
                <th style="width: 100px;">Condición</th>
                <th style="width: 60px; text-align: center;">Estatus</th>
                <th style="width: 90px;">Acción</th>
                <th style="width: 60px; text-align: center;">Estatus</th>
              </tr>
            </thead>
            <tbody>
              ${this._renderItemsTabla(items)}
            </tbody>
          </table>
        </div>
      </div>
      <div class="chk-cards-container">
        ${this._renderItemsCards(items)}
      </div>
    `;
  },

  // ======================== TABS ========================

  showTab(tab) {
    document.querySelectorAll('.pnc-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.pnc-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    document.querySelectorAll('.pnc-panel').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-${tab}`);
    if (panel) panel.style.display = 'block';

    if (tab === 'firmas' && this.data.checklist && !this.data.isNew) {
      this._renderFirmasDinamicas();
      this.initFirmas();
    }
  },

  // ======================== ACCIONES ========================

  // Los checkboxes de items se renderizan dos veces: en .chk-table-container
  // (escritorio) y en .chk-cards-container (móvil). CSS oculta una u otra
  // según viewport (breakpoint 768px). Leemos del contenedor que corresponde
  // al viewport actual con matchMedia — no por visibilidad en pantalla, porque
  // cuando el usuario está en otro tab (Notas / Responsables) el panel
  // Documento queda display:none y ambas copias dan offsetParent=null.
  _getCheckState(numero, field) {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const container = isMobile ? '.chk-cards-container' : '.chk-table-container';
    const cb = document.querySelector(
      `${container} input[data-item="${numero}"][data-field="${field}"]`
    );
    return cb ? cb.checked : false;
  },

  async guardarCambios() {
    const c = this.data.checklist;

    // Recoger items
    const items = [];
    DOCUMENTOS_TEMPLATE.forEach(tmpl => {
      items.push({
        numero: tmpl.numero,
        condicion: this._getCheckState(tmpl.numero, 'condicion'),
        accion: this._getCheckState(tmpl.numero, 'accion')
      });
    });

    const tipoVenta = document.querySelector('input[name="chkTipoVentaEdit"]:checked')?.value || null;

    const data = {
      fecha: document.getElementById('chkFechaEdit')?.value || null,
      tipo_venta: tipoVenta,
      notas: document.getElementById('chkNotas')?.value?.trim()?.toUpperCase() || null,
      items
    };

    try {
      this._showProgress('Subiendo firmas...');

      // Subir firmas nuevas
      const firmaUrls = await this.subirFirmas();
      Object.assign(data, firmaUrls);

      this._showProgress('Guardando cambios...');
      await ventasService.actualizarChecklistDocumentos(c.id, data);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Cambios guardados');
      await this.cargarChecklist(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al guardar cambios');
    }
  },

  async completarChecklist() {
    // Si hay cambios pendientes, exigir guardar primero
    if (this.data.hasUnsavedChanges) {
      toast.warning('Guarde los cambios antes de completar el checklist');
      return;
    }

    const c = this.data.checklist;

    // Validar que todos los checkboxes activos estén marcados
    const items = c.items || [];
    let faltantes = 0;
    DOCUMENTOS_TEMPLATE.forEach(tmpl => {
      if (!tmpl.condicion_bloqueada && !this._getCheckState(tmpl.numero, 'condicion')) {
        faltantes++;
      }
      if (!tmpl.accion_bloqueada && !this._getCheckState(tmpl.numero, 'accion')) {
        faltantes++;
      }
    });

    if (faltantes > 0) {
      toast.error(`Faltan ${faltantes} estatus por marcar`);
      this.showTab('documento');
      return;
    }

    // Validar firmas persistidas
    for (const tipo of ['responsable_linea', 'responsable_area']) {
      if (!c[`${tipo}_firma_url`]) {
        toast.error('Faltan firmas');
        this.showTab('firmas');
        return;
      }
    }

    if (!confirm('¿Completar este checklist? Esta acción no se puede deshacer.')) return;

    try {
      // Recoger items
      const itemsData = [];
      DOCUMENTOS_TEMPLATE.forEach(tmpl => {
        itemsData.push({
          numero: tmpl.numero,
          condicion: this._getCheckState(tmpl.numero, 'condicion'),
          accion: this._getCheckState(tmpl.numero, 'accion')
        });
      });

      const data = {
        notas: document.getElementById('chkNotas')?.value?.trim()?.toUpperCase() || null,
        items: itemsData,
        completada: true
      };

      this._showProgress('Completando checklist...');
      await ventasService.actualizarChecklistDocumentos(c.id, data);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Checklist completado exitosamente');
      await this.cargarChecklist(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al completar checklist');
    }
  },

  // ======================== FIRMAS ========================

  _renderFirmasDinamicas() {
    const container = document.getElementById('firmasContainer');
    if (!container) return;

    const c = this.data.checklist || {};

    this.signaturePad_responsable_linea = null;
    this.signaturePad_responsable_area = null;

    container.innerHTML = `
      ${this._renderFirmaEdicion('responsable_linea', 'Responsable de línea de producto', c.responsable_linea, c.responsable_linea_firma_url)}
      ${this._renderFirmaEdicion('responsable_area', 'Responsable de área de producción', c.responsable_area, c.responsable_area_firma_url)}
    `;
  },

  _renderFirmaEdicion(tipo, label, nombre, existingUrl) {
    if (existingUrl) {
      return `
        <div class="firma-container-new" style="text-align: center;">
          <label class="form-label firma-label">${label}</label>
          <p style="margin: 0 0 0.5rem; font-weight: 600;">${nombre || ''}</p>
          <img src="${existingUrl}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
          <a href="javascript:void(0)" class="firma-limpiar" onclick="window.checklistDocDetalleView.cambiarFirmaExistente('${tipo}')">Cambiar firma</a>
        </div>
      `;
    }
    return `
      <div class="firma-container-new" style="text-align: center;">
        <label class="form-label firma-label">${label}</label>
        <p style="margin: 0 0 0.5rem; font-weight: 600;">${nombre || ''}</p>
        <div class="firma-box">
          <canvas id="firma-${tipo}" class="firma-canvas-new"></canvas>
          <span class="firma-placeholder" id="firma-placeholder-${tipo}">Toque para firmar</span>
        </div>
        <a href="javascript:void(0)" class="firma-limpiar" onclick="window.checklistDocDetalleView.limpiarFirma('${tipo}')">Limpiar</a>
      </div>
    `;
  },

  async initFirmas() {
    if (!window.SignaturePad) {
      try {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar SignaturePad'));
          document.head.appendChild(script);
        });
      } catch (e) { toast.error('Error al cargar librería de firmas'); return; }
    }

    setTimeout(() => {
      ['responsable_linea', 'responsable_area'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas || this[`signaturePad_${tipo}`]) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });
        this[`signaturePad_${tipo}`] = pad;

        const placeholder = document.getElementById(`firma-placeholder-${tipo}`);
        if (placeholder) {
          canvas.addEventListener('pointerdown', () => placeholder.style.display = 'none');
        }

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const placeholder = document.getElementById(`firma-placeholder-${tipo}`);
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  cambiarFirmaExistente(tipo) {
    const c = this.data.checklist;
    if (c) c[`${tipo}_firma_url`] = null;
    this._showUnsaved();
    this.renderFormularioEdicion();
    this.showTab('firmas');
  },

  async subirFirmas() {
    const urls = {};
    const uploads = [];
    const c = this.data.checklist;
    const numSerie = c?.num_serie;

    for (const tipo of ['responsable_linea', 'responsable_area']) {
      // Guarda por URL: solo subir si NO existe URL persistida.
      // "Cambiar firma" pone la URL a null, así que la única vía para re-subir es ese flujo.
      const urlExistente = c?.[`${tipo}_firma_url`];
      const pad = this[`signaturePad_${tipo}`];
      if (!urlExistente && pad && !pad.isEmpty()) {
        const blob = await this.toBlob(pad);
        uploads.push(
          recepcionService.subirFirma(blob, `firma-${tipo}-chk-${Date.now()}.png`, numSerie, 'checklist_documentos')
            .then(url => { urls[`${tipo}_firma_url`] = url; })
        );
      }
    }

    if (uploads.length > 0) await Promise.all(uploads);
    return urls;
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  imprimir() {
    if (!this.data.checklist) return;
    router.navigate(`/ventas/checklist-entrega/${this.data.checklist.id}/print`);
  },

  async descargarPDF() {
    const c = this.data.checklist;
    if (!c) return;

    toast.info('Generando PDF...');

    try {
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      const { default: PrintView } = await import('./PrintChecklistDocumentos.js');

      const contentEl = document.getElementById('content');
      const savedHTML = contentEl.innerHTML;

      const html = PrintView.generateHTML(c);
      contentEl.innerHTML = html;

      const imgs = contentEl.querySelectorAll('img');
      await Promise.all(Array.from(imgs).map(img =>
        img.complete ? Promise.resolve() : new Promise(res => { img.onload = res; img.onerror = res; })
      ));

      await new Promise(res => setTimeout(res, 300));

      const opt = {
        margin: 0,
        filename: `Checklist_Entrega_${c.num_serie || c.id}.pdf`,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'] }
      };

      await html2pdf().set(opt).from(contentEl).save();
      contentEl.innerHTML = savedHTML;
      toast.success('PDF descargado');
    } catch (error) {
      toast.error(error.message || 'Error al generar PDF');
    }
  },

  volver() {
    if (this._hasUnsaved) {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    this._clearUnsaved();
    router.navigate('/ventas/checklist-entrega');
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    this.data.hasUnsavedChanges = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    this.data.hasUnsavedChanges = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
  }
};
